// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".W6wnA9fNivZzdOyWaGU4 {\n\tmargin: 0;\n}\n", "",{"version":3,"sources":["webpack://./client/src/components/Checkbox/Checkbox.module.css"],"names":[],"mappings":"AAAA;CACC,SAAS;AACV","sourcesContent":[".suffix {\n\tmargin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"suffix": "W6wnA9fNivZzdOyWaGU4"
};
export default ___CSS_LOADER_EXPORT___;
